import React from 'react';
import '../../styles/PresentationHomogene.css';
import ImgGareTrooRdc1 from '../../images/Rdc1.jpg';
import ImgGareTrooRdc2 from '../../images/Rdc2.jpg';

const Rdc = () => {
    return (
        <div className='presentation-section'>
            <div className='presentation-card'>
                <div className='section-header'>
                    <h1 className='section-title'>Le Rez de Chaussée</h1>
                </div>
                
                <div className='section-content'>
                    <div className='section-image'>
                        <img src={ImgGareTrooRdc1} alt="Rez-de-chaussée de la Gare de Troo" />
                    </div>
                    <div className='section-text'>
                        <p className='section-description'>
                            Au rez-de-chaussée des photos anciennes des gares de la région,
                            une exposition d'outils préhistoriques et de fossiles trouvés dans la région
                            ainsi qu'une boutique de souvenirs (cartes postales, magnets, livres sur la région, mugs, sets de table,…) et une buvette.
                        </p>
                    </div>
                    <div className='section-image'>
                        <img src={ImgGareTrooRdc2} alt="Exposition du rez-de-chaussée" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rdc;